export default __webpack_public_path__ + "static/media/footer_bg_img.dffeb46e.svg";